import { setLogger } from './api/logger';
import { show, removeByIds, removeAll, remove } from './api/external-notifications';
import { setVisibility } from './api/preview-bar';

export const setAPIConfig = (config) => {
  setLogger(config);
};
export {
  getAll as getAllExternalNotifications,
  dismissAll as dismissAllExternalNotifications,
  onChange as onExternalNotificationsChange,
  unbind as unbindExternalNotifications,
} from './api/external-notifications';
export {
  getVisibility as getPreviewBarVisibility,
  onVisibilityChange as onPreviewBarVisibilityChange,
  unbindVisibility as unbindPreviewBarVisibility,
} from './api/preview-bar';
export const externalNotificationsApi = {
  show, removeByIds, removeAll, remove,
};
export const previewBarApi = { setVisibility };
